import {Component, OnInit, Inject, Output} from "@angular/core";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from "@angular/material";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

import {CommonService, AlertService, AdminService} from "../../../_services/";
import {Subscription} from "rxjs";

@Component({
  selector: "app-project-map-field",
  templateUrl: "./project-map-field.component.html",
  styleUrls: ["./project-map-field.component.scss"],
})
export class ProjectMapFieldComponent implements OnInit {
  addNewProjectMapFieldForm: FormGroup;
  submitted: Boolean = false;
  successMsg: String;
  errMsg: String;
  projectMapStep: String;
  projectMapStepId: String;
  projectMapField: any[] = [];
  editFieldMode: Boolean = false;
  editFieldId: String;
  showSelectList: Boolean = false;
  private subscription: Subscription;
  constructor(
    public dialogRef: MatDialogRef<ProjectMapFieldComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private _common: CommonService,
    private _alert: AlertService,
    private _admin: AdminService
  ) {}

  ngOnInit() {
    this.projectMapStep = this.data.name ? this.data.name : "";
    this.projectMapStepId = this.data.id;
    this.getProjectMapFieldList();
    this.addNewProjectMapFieldForm = this.fb.group({
      name: [null, [Validators.required, Validators.maxLength(50)]],
      field_type: ["", [Validators.required]],
      notify: [null, []],
      select_list: [null, []],
    });
  }

  hideProjectMapFieldDialog() {
    this.dialogRef.close();
  }

  get fval() {
    return this.addNewProjectMapFieldForm.controls;
  }

  getProjectMapFieldList() {
    this._common.showLoader(true);
    this.subscription = this._admin
      .getProjectMapFieldList(this.projectMapStepId)
      .subscribe(
        (result) => {
          this._common.showLoader(false);
          this.projectMapField = result;
        },
        (err) => {
          this._common.showLoader(false);
          this._alert.error(
            err.error.message ? err.error.message : "Something went wrong!"
          );
        }
      );
  }

  showHide() {
    if (this.addNewProjectMapFieldForm.value.field_type === "select") {
      this.showSelectList = true;
    } else {
      this.showSelectList = false;
    }
  }

  onFormSubmit(): void {
    this.submitted = true;
    if (this.addNewProjectMapFieldForm.invalid) {
      return;
    }
    let form = this.addNewProjectMapFieldForm.value;
    form.uid = localStorage.getItem("uid");
    form.project_map_step_id = this.projectMapStepId;
    this._common.showLoader(true);
    if (this.editFieldMode == true) {
      let data = {
        name: this.addNewProjectMapFieldForm.value.name,
        field_type: this.addNewProjectMapFieldForm.value.field_type,
        select_list:
          this.addNewProjectMapFieldForm.value.select_list.split(","),
        notify:
          this.addNewProjectMapFieldForm.value.notify !== undefined &&
          this.addNewProjectMapFieldForm.value.notify.length > 0
            ? this.addNewProjectMapFieldForm.value.notify.split(",")
            : [],
      };
      this._admin.editProjectMapStepField(data, this.editFieldId).then(
        (res) => {
          this._common.showLoader(false);
          // this.dialogRef.close();
          // this._alert.success();
          this.editFieldMode = false;
          this.editFieldId = "";
          this.submitted = false;
          this.addNewProjectMapFieldForm.reset();
          this.successMsg = "Project map step field edited successfully!";
        },
        (err) => {
          this._common.showLoader(false);
          this.errMsg = err.message ? err.message : "Something went wrong";
        }
      );
    } else {
      this._admin.createProjectMapField(form).subscribe(
        (res) => {
          this._common.showLoader(false);
          this.submitted = false;
          this.addNewProjectMapFieldForm.reset();
          this.successMsg = res.message;
        },
        (err) => {
          this.dialogRef.close();
          this._common.showLoader(false);
          // this._alert.error();
          this.errMsg = err.error.message
            ? err.error.message
            : "Something went wrong!";
        }
      );
    }
  }

  deleteProjectMapFieldById(uid) {
    this._common.showLoader(true);
    this._admin
      .deleteProjectMapFieldById(uid)
      .then((res) => {
        this.cancelEdit();
        this._common.showLoader(false);
        this.successMsg = "Project map field deleted successfully!";
      })
      .catch((err) => {
        this._common.showLoader(false);
        this.errMsg = err.error.message
          ? err.error.message
          : "Something went wrong!";
      });
  }
  openEditProjectMapFieldDialog(id, data) {
    if (data.field_type === "select") {
      this.showSelectList = true;
    } else {
      this.showSelectList = false;
    }
    this.successMsg = "";
    this.errMsg = "";
    this.editFieldMode = true;
    this.editFieldId = id;
    this.addNewProjectMapFieldForm.patchValue({
      name: data.name,
      field_type: data.field_type,
      select_list:
        data.select_list && data.select_list.length > 0
          ? data.select_list.join(",")
          : "",
      notify: data.notify ? data.notify.join(",") : "",
    });
  }

  cancelEdit() {
    this.editFieldMode = false;
    this.editFieldId = "";
    this.addNewProjectMapFieldForm.reset();
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
